export const assertKeysAreNumbers = (obj: Object): Record<any, number> => {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, assertNumber(value)]))
}

const assertNumber = (value: string): number => {
  if (typeof value === 'number') return value

  if (typeof value === 'string' && !isNaN(Number(value))) {
    return Number(value)
  }

  return 0
}
